import { StringUtil } from '@nomidio/common';

export enum ServerPermission {
  /** @deprecated replaced by IDP_ACCESS */
  OpenIdUserManagement = 'OPEN_ID_USER_MANAGEMENT',
  /** @deprecated replaced by IDP_CLIENTS */
  OpenIdClientManagement = 'OPEN_ID_CLIENT_MANAGEMENT',
  /** @deprecated replaced by DIRECTORIES */
  OpenIdDirectoryManagement = 'OPEN_ID_DIRECTORY_MANAGEMENT',
  /** @deprecated replaced by BLOCKING*/
  BlockedUserManagement = 'BLOCKED_USER_MANAGEMENT',

  Details = 'DETAILS',
  Accounts = 'ACCOUNTS',
  Support = 'SUPPORT',
  Monitoring = 'MONITORING',
  Sales = 'SALES',
  Audit = 'AUDIT',
  Reports = 'REPORTS',
  Blocking = 'BLOCKING',
  IdpAccess = 'IDP_ACCESS',
  IdpClients = 'IDP_CLIENTS',
  Directories = 'DIRECTORIES',
}

export function ServerPermissionPresentation(perm: ServerPermission): string {
  switch (perm) {
    case ServerPermission.IdpAccess:
    case ServerPermission.OpenIdUserManagement:
      return 'IDP Access Management';
    case ServerPermission.IdpClients:
    case ServerPermission.OpenIdClientManagement:
      return 'IDP Client Management';
    case ServerPermission.Directories:
    case ServerPermission.OpenIdDirectoryManagement:
      return 'IDP Directory Management';
    case ServerPermission.Blocking:
    case ServerPermission.BlockedUserManagement:
      return 'Blocked User Management';
    case ServerPermission.Details:
        return 'Details';
    case ServerPermission.Accounts:
      return 'Accounts';
    case ServerPermission.Support:
      return 'Support';
    case ServerPermission.Monitoring:
      return 'Monitoring';
    case ServerPermission.Sales:
      return 'Sales';
    case ServerPermission.Audit:
      return 'Audit';
    case ServerPermission.Reports:
      return 'Reports';
    default:
      console.warn(`Mapping not handled for type '${perm}' falling back to value`);
      return StringUtil.toPresentationFormat(perm);
  }
}
